import { TASK_EVENT_TYPE } from '../constants/task-event-type';

export class TaskListCardUtils {
  static isPreparationType(eventType: string): boolean {
    const {
      POST_EXAM_SCHEDULE,
      POST_CONSULTATION_SCHEDULE,
      POST_SERVICE_SCHEDULE,
      POST_SURGERY_SCHEDULE,
      GOING_TO_PROMPT_SERVICE,
    } = TASK_EVENT_TYPE;

    const preparationTypes = [
      POST_EXAM_SCHEDULE,
      POST_CONSULTATION_SCHEDULE,
      POST_SERVICE_SCHEDULE,
      POST_SURGERY_SCHEDULE,
      GOING_TO_PROMPT_SERVICE
    ];

    return preparationTypes.some(item => item === eventType);
  }

  static isPostProcedureType(eventType: string): boolean {
    const {
      POST_CONSULTATION_SCHEDULE_EXEC,
      POST_EXAM_SCHEDULE_EXEC,
      POST_SERVICE_SCHEDULE_EXEC,
      POST_SURGERY_SCHEDULE_EXEC,
      POST_PATIENT_DISCHARGE
    } = TASK_EVENT_TYPE;

    const postProcedureTypes = [
      POST_CONSULTATION_SCHEDULE_EXEC,
      POST_EXAM_SCHEDULE_EXEC,
      POST_SERVICE_SCHEDULE_EXEC,
      POST_SURGERY_SCHEDULE_EXEC,
      POST_PATIENT_DISCHARGE
    ];

    return postProcedureTypes.some(item => item === eventType);
  }
}
